module.exports = __webpack_public_path__ + "static/img/Jaydn-Su’A.5783b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jaydn-Su’A.jpg
// module id = QMjs
// module chunks = 0